/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'cportal';
const componentName = 'cportal-info-preview';
const prefix = `${moduleName}.${componentName}`;

export const portalUrlLabel = `${prefix}.portalUrlLabel`;
export const siteIdLabel = `${prefix}.siteIdLabel`;

export const ENGLISH = {
    [portalUrlLabel]: 'Cloud Services Portal URL',
    [siteIdLabel]: 'Site ID',
};
